
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 6c3.766 0 7.094.392 9.125.688 1.679.245 3.035 1.512 3.344 3.188.264 1.429.531 3.518.531 6.125s-.268 4.697-.531 6.125c-.309 1.677-1.664 2.944-3.344 3.188-2.038.296-5.379.688-9.125.688s-7.088-.392-9.125-.688c-1.679-.243-3.034-1.512-3.344-3.188C3.268 20.7 3 18.613 3 16.001s.268-4.698.531-6.125c.309-1.675 1.666-2.943 3.344-3.188C8.906 6.392 12.233 6 16 6zm0 2c-3.633 0-6.881.37-8.844.656A1.961 1.961 0 005.5 10.25C5.257 11.57 5 13.521 5 16s.257 4.43.5 5.75a1.963 1.963 0 001.656 1.594C9.127 23.63 12.389 24 16 24s6.872-.37 8.844-.656A1.96 1.96 0 0026.5 21.75c.243-1.322.5-3.279.5-5.75s-.256-4.429-.5-5.75a1.963 1.963 0 00-1.656-1.594A62.988 62.988 0 0016 8zm-3 2.281l1.5.844 7 4L23 16l-1.5.875-7 4-1.5.844V10.281zm2 3.438v4.563l3.969-2.281z"}})])
          )
        }
      }
    